<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>

            <h2 class="text-center pt2 pb-4">Видео</h2>

            <div v-for="(intensive, index) in informing.intensives">
                <b-alert class="mb-4" variant="info" show>
                    <div v-html="intensive.text"></div>
                    <div v-if="intensive.pay === 0">
                    Стоимость: {{ intensive.cost }} {{ intensive.name }}.<br>
                    <div :id="index + '_intPayBtn'">
                        <b-button class="btn-sm btn-success" @click="intensivePay(intensive.teacher_id, index)">
                            Зарегистрироваться и оплатить
                        </b-button>
                    </div>
                    </div>
                </b-alert>
            </div>

            <div v-for="message in informing.messages">
                <b-alert class="mb-4" variant="info" show>
                    {{ message.text }}
                </b-alert>
            </div>

            <div class="mt-2">
                <b-card-group deck class="pb-4">

                    <b-card header-bg-variant="light" class="text-center">
                        <template #header class="card-header">
                            <h4 class="mb-0 text-bold">Онлайн тренировки</h4>
                        </template>
                        <b-card-text>
                            <div v-for="(video, index) in videos.online" :key="video.id">
                                <div v-if="video.player === 'hidden'">
                                </div>
                                <div v-else-if="video.player === ''">
                                    <div class="mb-4">
                                        <b-btn class="w-100 btn-info" @click="payModalOnline(video, index)">
                                            <span class="play_btn"></span>
                                            {{ video.date.substr(0, 10) }} <b>{{
                                                getDay(JSON.parse(video.time).day)
                                            }}</b>
                                            {{ JSON.parse(video.time).start.substring(0, 5) }}
                                            {{ video.name }}
                                        </b-btn>
                                        <div :id="video.id + '_online'"></div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="mb-4">
                                        <b-btn class="w-100 btn-success" @click="getPlayerOnline(video, index)">
                                            <span class="play_btn"></span>
                                            {{ video.date.substr(0, 10) }} <b>{{
                                                getDay(JSON.parse(video.time).day)
                                            }}</b>
                                            {{ JSON.parse(video.time).start.substring(0, 5) }}
                                            {{ video.name }}
                                        </b-btn>
                                        <div :id="video.id + '_online'"></div>
                                    </div>
                                </div>
                                <div v-show="show[index]" class="text-center">
                                    <div class="pb-4">
                                        <b-spinner variant="primary" label="Text Centered"></b-spinner>
                                    </div>
                                </div>
                            </div>
                            <b-alert show variant="info">Время сервера: <b>{{ this.time }}</b><br>
                                До следующей тренировки:<br>
                                ({{ this.teacher }})<br>
                                <b>{{ this.diffTime }}</b><br>
                                После включения появится кнопка.
                            </b-alert>
                        </b-card-text>
                    </b-card>

                    <b-card header-bg-variant="light" class="text-center">
                        <template #header class="card-header">
                            <h4 class="mb-0 text-bold">Архивные тренировки</h4>
                        </template>
                        <b-card-text>
                            <div v-for="(video, index) in videos.archive" :key="video.id">
                                <div v-if="video.player === 'hidden'">
                                </div>
                                <div v-else-if="video.player === ''">
                                    <div class="mb-4">
                                        <b-btn class="w-100" @click="payModalArchive(video, index)">
                                            <span class="play_btn"></span>
                                            {{ video.date.substr(0, 10) }} <b>{{
                                                getDay(JSON.parse(video.time).day)
                                            }}</b>
                                            {{ JSON.parse(video.time).start.substring(0, 5) }}
                                            {{ video.name }}
                                        </b-btn>
                                        <div :id="video.id + '_archive'"></div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="mb-4">
                                        <b-btn class="w-100 btn-success" @click="getPlayer(video, index)">
                                            <span class="play_btn"></span>
                                            {{ video.date.substr(0, 10) }} <b>{{
                                                getDay(JSON.parse(video.time).day)
                                            }}</b>
                                            {{ JSON.parse(video.time).start.substring(0, 5) }}
                                            {{ video.name }}
                                        </b-btn>
                                        <div :id="video.id + '_archive'"></div>
                                    </div>
                                </div>
                                <div v-show="show[index]" class="text-center">
                                    <div class="pb-4">
                                        <b-spinner variant="primary" label="Text Centered"></b-spinner>
                                    </div>
                                </div>
                            </div>
                        </b-card-text>
                    </b-card>

                </b-card-group>
            </div>
            <template>
                <div>
                    <b-modal id="bv-modal-example" v-model="modalShow" title="Оплата">
                        <p class="my-4">За тренировку {{ this.workoutDate }} <br>
                            проводит: <b>{{ this.teacherName }}</b></p>
                        Стоимость: {{ this.workoutCost }} {{ this.workoutCurrency }}.
                        <b-alert class="mt-2" v-model="showDismissibleAlert" variant="danger">
                            На счету не достаточная сумма!
                        </b-alert>
                        <div v-if="showDismissibleAlert">
                            <b-button class="mt-3" variant="success" block @click="modalShow = false">Закрыть</b-button>
                        </div>
                        <div v-else>
                            <b-button v-if="sendPayOnline" class="mt-3" variant="success" block @click="getPayOnline()">
                                Подтвердить
                                оплату
                            </b-button>
                            <b-button v-if="sendPayArchive" class="mt-3" variant="success" block
                                      @click="getPayArchive()">
                                Подтвердить
                                оплату
                            </b-button>
                        </div>
                        <template #modal-footer>
                            <div class="w-100"></div>
                        </template>
                    </b-modal>
                </div>
            </template>
        </div>

        <div v-else>
            <LoginForm></LoginForm>
        </div>
    </div>
</template>

<script>
import LoginForm from "./Login";
import Cookies from "js-cookie";
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        informing: [],
        timeServer: 0,
        time: "",
        diffTimeServer: 0,
        teacher: '',
        diffTime: "",
        checkTime: false,
        videoBtn: '',
        currentTime: 100,
        show: [],
        sendPayOnline: true,
        sendPayArchive: true,
        clickId: null,
        clickItem: null,
        teacherName: null,
        workoutDate: null,
        workoutCost: null,
        workoutDay: null,
        workoutCurrency: null,
        currency: null,
        modalShow: false,
        errArray: [],
        dismissSecs: 10,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        timetables: [],
        costs: [],
        videos: [],
        allVideo: [],
        checkVideo: '',
        appUrl: 'https://slon.yoga',
        storedStatusJW: false,
        days: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']
    }),

    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/monitor')
                .then(response => {
                    this.allVideo = response.data;
                })
            this.axios
                .get('/api/time')
                .then(response => {
                    this.timeServer = response.data;
                    this.secondsFormat()
                })
            this.axios
                .get('/api/next_workout')
                .then(response => {
                    let content = response.data;
                    this.diffTimeServer = content.diff_time;
                    this.teacher = content.teacher;
                })
            this.axios
                .get('/api/video')
                .then(response => {
                    this.videos = response.data;
                })
            this.getInforming()
        }
    },

    components: {LoginForm},
    methods: {
        logout: function () {
            Cookies.remove('JWT');
            window.location.href = "/home/";
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        getDay(day) {
            return this.days[day];
        },
        playerjs: function (playerjsId, playerjsUrl) {
            var player = new Playerjs({id: playerjsId, file: this.appUrl + '/' + playerjsUrl});
        },
        payModalOnline(video, index) {
            this.sendPayOnline = true
            this.sendPayArchive = false
            this.showDismissibleAlert = false
            this.clickId = video.id
            this.clickItem = index
            this.teacherName = video.name
            this.workoutDate = video.date.substr(0, 16)
            this.workoutCost = video.price.cost
            this.workoutCurrency = video.price.name
            this.workoutDay = this.getDay(JSON.parse(video.time).day)
            this.modalShow = true
        },
        payModalArchive(video, index) {
            this.sendPayOnline = false
            this.sendPayArchive = true
            this.showDismissibleAlert = false
            this.clickId = video.id
            this.clickItem = index
            this.teacherName = video.name
            this.workoutDate = video.date.substr(0, 16)
            this.workoutCost = video.price.cost
            this.workoutCurrency = video.price.name
            this.workoutDay = this.getDay(JSON.parse(video.time).day)
            this.modalShow = true
        },
        getPayOnline() {
            this.axios
                .get('/api/pay_video/' + this.clickId)
                .then(response => {
                    let videoCode = response.data;
                    if (videoCode) {
                        this.show[this.clickItem] = true
                        this.videos.online[this.clickItem].player = '<div class="font-weight-bolder p-2 bg-success">' + this.workoutDay + ' ' + this.workoutDate.substring(11, 17) + ' ' + this.teacherName + '</div>'
                        this.modalShow = false
                        setTimeout(() =>
                                this.show = []
                            , 100);
                        setTimeout(() =>
                                new Playerjs({
                                    id: this.clickId + '_online',
                                    file: this.appUrl + '/slon_online/' + videoCode + '.m3u8'
                                })
                            , 150);
                        this.updateBalance()
                    } else {
                        this.sendPay = false
                        this.showDismissibleAlert = true
                    }
                })
        },
        getPayArchive() {
            this.axios
                .get('/api/pay_video/' + this.clickId)
                .then(response => {
                    let videoCode = response.data;
                    if (videoCode) {
                        this.show[this.clickItem] = true
                        this.videos.archive[this.clickItem].player = '<div class="font-weight-bolder p-2 bg-success">' + this.workoutDay + ' ' + this.workoutDate.substring(11, 17) + ' ' + this.teacherName + '</div>'
                        this.modalShow = false
                        setTimeout(() =>
                                this.show = []
                            , 100);
                        setTimeout(() =>
                                new Playerjs({
                                    id: this.clickId + '_archive',
                                    file: this.appUrl + '/slon_archive/' + videoCode
                                })
                            , 150);
                        this.updateBalance()
                    } else {
                        this.sendPay = false
                        this.showDismissibleAlert = true
                    }
                })
        },
        getPlayer(video, index) {
            console.log(video.player)
            new Playerjs({id: video.id + '_archive', file: this.appUrl + '/slon_archive/' + video.player})
        },
        getPlayerOnline(video, index) {
            console.log(video.player)
            new Playerjs({id: video.id + '_online', file: this.appUrl + '/slon_online/' + video.player + '.m3u8'})
        },
        startTimer() {
            this.timer = setInterval(() => {
                this.currentTime--
                this.axios
                    .get('/api/monitor')
                    .then(response => {
                        this.allVideo = response.data;
                    })
                // archive
                let massiv1 = this.allVideo.archive
                let massiv2 = this.videos.archive.map(function (value) {
                    return value.id
                });
                let videoType = 'archive'
                this.changeButtons(massiv1, massiv2, videoType)
                // online
                massiv1 = this.allVideo.online
                massiv2 = this.videos.online.map(function (value) {
                    return value.id
                });
                videoType = 'online'
                this.changeButtons(massiv1, massiv2, videoType)
            }, 10000)
        },
        updateBalance() {
            setTimeout(() =>
                    this.axios
                        .get('/api/balance')
                        .then(response => {
                            this.$store.commit('setBalance', response.data);
                        })
                , 500);
        },
        // stopTimer() {
        //     clearTimeout(this.timer)
        // },
        getInformingStart() {
            setInterval(() =>
                    this.getInforming()
                , 10000);
        },

        getInforming() {
            this.axios
                .get('/api/informing')
                .then(response => {
                    this.informing = response.data;
                })
        },
        intensivePay(teacherId, index) {
            let message = 'ожидайте...'
            document.getElementById(index + '_intPayBtn').textContent = message
            this.axios
                .get('/api/pay_intensive/' + teacherId)
                .then(response => {
                    let payIntensive = response.data;
                    if (payIntensive) {
                        message = 'Оплата прошла успешно.'
                    } else {
                        message = 'Проверьте свой баланс, если есть ошибка то свяжитесь с администратором.'
                    }
                    document.getElementById(index + '_intPayBtn').textContent = message
                    setTimeout(()=> {
                        this.getInforming()
                    },2000)
                })
        },
        clock() {
            setInterval(() => {
                    this.secondsFormat()
                    this.diffSecondsFormat()
                    this.timeServer++
                    this.diffTimeServer -= 1
                    if (this.checkTime) {
                        this.axios
                            .get('/api/next_workout')
                            .then(response => {
                                let content = response.data;
                                this.diffTimeServer = content.diff_time;
                                this.teacher = content.teacher;
                            })
                        this.checkTime = false
                    }
                }
                , 1000)
        },

        secondsFormat() {
            let date = new Date(this.timeServer * 1000);
            let h = date.getHours()
            if (h < 10) {
                h = '0' + h
            }
            let m = date.getMinutes()
            if (m < 10) {
                m = '0' + m
            }
            let s = date.getSeconds()
            if (s < 10) {
                s = '0' + s
            }
            this.time = h + ':' + m + ':' + s;
        },

        diffSecondsFormat() {
            let time = this.diffTimeServer
            let day = 0, H = 0, min = 0, sec = 0
            if (time > 86400) {
                day = Math.floor((time / 86400))
            }
            H = Math.floor((time - (day * 86400)) / 3600)
            min = Math.floor((time - ((day * 86400) + (H * 3600))) / 60)
            sec = Math.floor((time - ((day * 86400) + (H * 3600) + (min * 60))))
            if (day === 0 && H === 0 && min === 0 && sec === 0) {
                this.checkTime = true
            }
            this.diffTime = day + ' дней ' + H + ' часов ' + min + ' мин. ' + sec + ' сек.'
        },

        changeButtons(massiv1, massiv2, videoType) {
            var set1 = Array.from(new Set(massiv1))
            var set2 = Array.from(new Set(massiv2))

            var arrayDiff1 = set1.filter(i => !set2.includes(i))
            var arrayDiff2 = set2.filter(i => !set1.includes(i))

            // create
            if (arrayDiff1.length > 0) {
                arrayDiff1.forEach(function (item) {
                    if (videoType === 'archive') {
                        let even = (element) => element === item
                        let checkBtn = this.videos.archive.some(even)
                        if (checkBtn) {
                        } else {
                            this.axios
                                .get('/api/video_btn/archive/' + item)
                                .then(response => {
                                    this.videos.archive.unshift(response.data)
                                }, this)
                        }
                    }
                    if (videoType === 'online') {
                        let even = (element) => element === item
                        let checkBtn2 = this.videos.online.some(even)
                        if (checkBtn2) {
                        } else {
                            this.axios
                                .get('/api/video_btn/online/' + item)
                                .then(response => {
                                    this.videos.online.unshift(response.data)
                                }, this)
                        }
                    }
                }, this);
            }
            // delete
            if (arrayDiff2.length > 0) {
                arrayDiff2.forEach(function (item) {
                    if (videoType === 'archive') {
                        this.videos.archive.forEach(function (itemVideo, i) {
                            if (item === itemVideo.id) {
                                this.videos.archive.splice(i, 1);
                            }
                        }, this);
                    }
                    if (videoType === 'online') {
                        this.videos.online.forEach(function (itemVideo, i) {
                            if (item === itemVideo.id) {
                                this.videos.online.splice(i, 1);
                            }
                        }, this);
                    }
                }, this);
            }
        }
    },
    computed: {
        ...mapGetters([
            'storedStatusJWT',
            'storedUserBalance'
        ])
    },
    destroyed() {
        this.stopTimer()
    },
    mounted() {
        this.startTimer()
        this.clock()
        this.getInformingStart()
    },
    watch: {
        // currentTime(time) {
        //     if (time === 0) {
        //         this.stopTimer()
        //     }
        // }
    },

}
</script>
<style>
@media screen {
    .form_login {
        width: 300px;
    }
}

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}

.modal-backdrop {
    opacity: 0.5;
}

.play_btn:after {
    content: '\25B6';
    float: left;
    box-shadow: 1px 1px 15px #0b542a;
    padding-left: 8px;
    padding-right: 5px;
    margin-left: -7px;
}

</style>
